const emptyUnitsState = {
  units: [],
  selectedUnit: null,
  editUnit: null,
  userUnits: [],
  sharedUnitsList: [],
  floorplans: [],
  accessRequests: [],
  notices: [],
  invitationsList: [],
  userRelation: null,
  totalPages: 1,
  totalFound: 0,
  bpUnitsTotal: 0,
  bpUnitsBpId: null,
  loading: false,
  fetched: false,
  error: null,
  unitAccess: {
    requests: { loading: false, data: [], error: null },
    invitations: { loading: false, data: [], error: null },
    revoked: { loading: false, data: [], error: null }
  },
  currentUnit: {
    loading: false,
    error: null,
    data: null
  }
}

export default emptyUnitsState
